// Handle immobilize targeting
import i18n from '../i18n';
import { getBattleActionBlockErrorKey } from '../utils/battleActionBlockError';

const targetImmobilize = (targetZone, targetIndex, ws, setError, setImmobilizeTargetMode, setSelectedImmobilizeWeaponId) => {
  const blockKey = getBattleActionBlockErrorKey({
    requireGameId: false,
    socket: ws,
  });
  if (blockKey) {
    setError(i18n.t(blockKey));
    return;
  }

  // Send immobilize targeting action
  const action = {
    type: "targetImmobilize", 
    targetUnitId: "opponent",
    targetZone: targetZone,
    targetIndex: targetIndex
  };

  ws.send(JSON.stringify(action));
  
  // Reset immobilize targeting
  setImmobilizeTargetMode(false);
  setSelectedImmobilizeWeaponId(null);
};

export default targetImmobilize;
